import { provideRouter } from '@angular/router';
import { UserManagementRoutes } from './user-mgmt.routing';
import { UserMgmtReducer, UserMgmtState } from './state/reducer/user-mgmt.reducer';
import { MetaReducer, Action, provideState } from '@ngrx/store';
import { UserMgmtEffects } from './state/effects/user-mgmt.effects';
import { provideEffects } from '@ngrx/effects';
import { userMgmtStateKey } from './state';
import { createLocalStorageSyncReducer } from '../../shared/utils/local-storage-sync';

const localStorageSyncReducer = createLocalStorageSyncReducer<UserMgmtState>([
  'selectedUser',
  'getUserList',
  'getMeUser',
]);

const metaReducers: Array<MetaReducer<UserMgmtState, Action>> = [localStorageSyncReducer];

export const userManagmentConfig = [
  provideState(userMgmtStateKey, UserMgmtReducer, { metaReducers }),
  provideRouter(UserManagementRoutes),
  provideEffects([UserMgmtEffects]),
];
